// Reutiliza a paleta de cores do varal — mantida localmente pois
// TvInvasaoJuninaTakeover (feature jukebox) é interna àquela feature.
const CORES_BANDEIRINHA = [
  '#ef4444', '#f97316', '#eab308',
  '#22c55e', '#3b82f6', '#a855f7',
  '#ec4899', '#ffffff',
];

function Bandeirinha({ cor, delay }: { cor: string; delay: number }) {
  return (
    <svg
      width="18" height="24" viewBox="0 0 20 28"
      className="shrink-0 animate-junina-balanco"
      style={{ animationDelay: `${delay}ms`, transformOrigin: 'top center' }}
    >
      <polygon points="0,0 20,0 10,28" fill={cor} opacity="0.9" />
    </svg>
  );
}

function Varal({ count, flip, offset = 0 }: { count: number; flip?: boolean; offset?: number }) {
  return (
    <div className={`relative flex items-start justify-around w-full px-1 ${flip ? 'rotate-180' : ''}`}>
      <div className="absolute top-[1px] left-0 right-0 h-[2px] bg-gradient-to-r from-yellow-800/40 via-yellow-600/60 to-yellow-800/40" />
      {Array.from({ length: count }, (_, i) => (
        <Bandeirinha
          key={i}
          cor={CORES_BANDEIRINHA[(i + offset) % CORES_BANDEIRINHA.length]}
          delay={i * 70}
        />
      ))}
    </div>
  );
}

export default function TvFestaJuninaTakeover({ hideBadge = false }: { hideBadge?: boolean }) {
  return (
    <div className="fixed inset-0 z-[14] pointer-events-none overflow-hidden">

      {/* Glow quente no rodapé */}
      <div
        className="absolute bottom-0 left-0 right-0 h-40"
        style={{ background: 'linear-gradient(to top, rgba(120,53,15,0.28) 0%, transparent 100%)' }}
      />

      {/* Varal superior */}
      <div className="absolute top-0 left-0 right-0 pt-0.5 animate-junina-varal-in">
        <Varal count={28} />
      </div>

      {/* Varal inferior — 1 fileira invertida */}
      <div
        className="absolute bottom-0 left-0 right-0 pb-0.5 animate-junina-varal-in"
        style={{ animationDelay: '120ms' }}
      >
        <Varal count={22} flip />
      </div>

      {!hideBadge && (
        <div
          className="absolute bottom-6 right-6 flex items-center gap-1.5 rounded-full px-3 py-1.5 backdrop-blur-sm"
          style={{
            background: 'rgba(120,53,15,0.70)',
            border:     '1px solid rgba(251,191,36,0.40)',
          }}
        >
          <span className="text-xs font-bold text-amber-300 tracking-wide">
            🎪 Arraiá do Espetos!
          </span>
        </div>
      )}

    </div>
  );
}
